/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Navigation is a server decision, never inferred from role IDs.
 */
export type AppsNavigationDecision = { userKind: 'INTERNAL' | 'EXTERNAL' | 'UNCLASSIFIED'; applications: Array<{ code: string; permissions: string[] }> };
export function parseAppsNavigation(value: unknown): AppsNavigationDecision | null {
  if (!value || typeof value !== 'object') return null;
  const row = value as Record<string, unknown>;
  if (!['INTERNAL', 'EXTERNAL', 'UNCLASSIFIED'].includes(String(row.userKind)) || !Array.isArray(row.applications)) return null;
  if (row.applications.some(app => !app || typeof app.code !== 'string' || !Array.isArray(app.permissions)
    || app.permissions.some((code: unknown) => typeof code !== 'string' || code === '*'))) return null;
  return row as AppsNavigationDecision;
}
export function filterNavigationApps<T extends { code: string }>(apps: T[], userKind: unknown, decision: AppsNavigationDecision | null): T[] {
  if (userKind === 'INTERNAL') return apps;
  if (userKind !== 'EXTERNAL' || decision?.userKind !== 'EXTERNAL') return [];
  const allowed = new Set(decision.applications.map(app => app.code));
  return apps.filter(app => allowed.has(app.code));
}
export function canShowExternalMenu(userKind: unknown, permission: string | undefined, userPermissions: string[], allowed: string[]): boolean {
  if (userKind !== 'EXTERNAL') return false;
  return Boolean(permission && permission !== '*' && userPermissions.includes(permission) && allowed.includes(permission));
}
